import { atom } from 'jotai';

/** 본문/코멘트 이미지 "크게보기" 모달 전역 상태 */
export type ImageZoomState = {
  open: boolean;
  src: string | null;
};

export const imageZoomAtom = atom<ImageZoomState>({
  open: false,
  src: null,
});
